import { ApisauceInstance } from 'apisauce';

const deleteCommitment = async (c: Commitment, api: ApisauceInstance) => {
  return api.delete(`/v1/commitments/delete_commitment?commitment_id=${c.id}`);
};

export default deleteCommitment;
